<template>
  <div class="container">
    <div class="header">
      <span>专题讲座{{ $route.query.type }}</span>
    </div>
    <div class="content">
      <el-form
        label-width="auto"
        :model="detailForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="学员名字：" prop="name">
          <span>{{ detailForm.userName }}</span>
        </el-form-item>
        <el-form-item label="工作单位：" prop="name">
          <span>{{ detailForm.deptName }}</span>
        </el-form-item>
        <el-form-item label="单位及职务：" prop="name">
          <span>{{ detailForm.unitPosition }}</span>
        </el-form-item>
        <el-form-item label="讲座主题：" prop="name">
          <span>{{ detailForm.lectureName }}</span>
        </el-form-item>
        <el-form-item label="授课老师：" prop="name">
          <span
            >{{ detailForm.teacher }}&emsp;{{
              detailForm.teacherUnitPosition
            }}</span
          >
        </el-form-item>
        <el-form-item label="讲座时间：" prop="name">
          <span>{{ detailForm.trainTimeStr }}</span>
        </el-form-item>
        <el-form-item label="学时（小时）：" prop="name">
          <span>{{ detailForm.lectureHours }}</span>
        </el-form-item>
        <el-form-item label="讲座地点：" prop="name">
          <span>{{ detailForm.lecturePlace }}</span>
        </el-form-item>
        <el-form-item label="主办单位：" prop="name">
          <span>{{ detailForm.organizer }}</span>
        </el-form-item>
        <el-form-item
          label="通知文件："
          prop="name"
          v-if="attachmentArr && attachmentArr.length > 0"
        >
          <span>{{ attachmentName }}</span>
          <span
            :class="[isPreview ? 'file_style' : 'unClick_style']"
            @click.stop="showImgPreview"
            >预览</span
          >
          <span class="file_style" @click="downloadFile">下载</span>
        </el-form-item>
        <!-- <el-form-item label="通知文件：" prop="name" v-else>
          <span>暂无</span>
        </el-form-item> -->
        <el-form-item
          class="img-box"
          label="现场照片："
          prop="name"
          v-if="sitePhotoArr && sitePhotoArr.length > 0"
        >
          <div
            class="img-item"
            v-for="(item, index) in sitePhotoArr"
            :key="index"
          >
            <img class="img" :src="item.url" alt="" />
            <i @click="imgIconEvent(item.url)" class="el-icon-zoom-in"></i>
          </div>
          <el-dialog class="img-dialog" :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div class="timeline">
        <div class="title">审核详情</div>
        <div class="timeline-box">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in detailForm.classAuditHistories"
              :key="index"
              :icon="activity.auditSchedule !== 8 ? 'el-icon-circle-check': ''"
              :type="activity.auditSchedule !== 8 ? 'primary': ''"
              :color="activity.color"
              :size="activity.size || 'large'"
            >
              <div v-if="activity.auditSchedule !== 8">
                {{ activity.auditUserName }}

                <div class="margin-top-10">
                  {{
                    activity.auditDate == null
                      ? ""
                      : activity.auditDate +
                        (activity.auditContent
                          ? "\u3000" + activity.auditContent
                          : "")
                  }}
                </div>
                <DealAttachment
                  class="margin-top-10"
                  v-if="
                    activity.auditAttachmentName !== undefined &&
                    activity.auditAttachmentName
                  "
                  :isPreview="
                    isImageType(
                      activity.auditAttachmentName.substr(
                        activity.auditAttachmentName.lastIndexOf('.') + 1
                      )
                    )
                  "
                  :name="activity.auditAttachmentName"
                  :url="JSON.parse(activity.auditAttachment)[0].url"
                />
                <div
                  class="margin-top-10"
                  v-if="
                    (activity.auditSchedule === 7 ||
                      activity.auditSchedule === 2) &&
                    activity.classPushStatusName !== undefined
                  "
                >
                  <span>{{
                    activity.historyPushTime +
                    "  " +
                    activity.classPushStatusName
                  }}</span>
                  <!-- <span class="deal-span" @click="asyncAgain(activity.uuid)"
                  >再次同步</span
                > -->
                </div>
              </div>
              <div v-else>
                <div
                  v-for="(item, j) in activity.auditUserNameList"
                  :key="'auditUserNameList' + j"
                  class="audit_item"
                >
                  <span>{{ item }}</span>
                  <span class="status_style">{{ activity.auditContent }}</span>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="submit-btn">
        <el-button size="small" @click="$router.push('/topicLectureReview')"
          >返回</el-button
        >
        <el-button
          v-if="type == '审核' "
          size="small"
          type="primary"
          @click="submit(detailForm.userName, $route.query.uuid)"
          >审核</el-button
        >
      </div>
    </div>
    <el-dialog title="专题讲座审核" :visible.sync="dialogExamine">
      <el-form
        :model="examineForm"
        :rules="rules"
        ref="examineForm"
        label-width="100px"
      >
        <el-form-item label="审核结果：" prop="auditSchedule">
          <el-radio-group
            v-model="examineForm.auditSchedule"
            @change="examineResultEvent"
          >
            <el-radio :label="2">不同意</el-radio>
            <el-radio :label="1">同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="驳回原因："
          v-if="examineForm.auditSchedule === 2"
          prop="auditContent"
        >
          <el-input
            type="textarea"
            placeholder="请输入驳回原因"
            v-model="examineForm.auditContent"
            maxlength="200"
            @input="reasonInputEvent"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="短信通知：" prop="isNotice">
          <el-radio-group
            v-model="examineForm.isNotice"
            @change="msgNoticeEvent"
          >
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消息内容：" prop="msg" v-if="examineForm.isNotice">
          <el-input
            type="textarea"
            v-model="examineForm.msg"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="sendobj-content" v-if="examineForm.isNotice">
        <div class="lable">发送对象：</div>
        <div class="text">
          <div
            :style="{ 'max-height': textOpenFlag ? textHeight : '' }"
            :class="{ unfoldText: textOpenFlag }"
            ref="desc"
          >
            {{ sendObj }}
          </div>
          <el-link
            :underline="false"
            v-if="showBtnFlag"
            @click="textOpenFlag = !textOpenFlag"
            class="btn"
            type="primary"
            >{{ textOpenFlag ? "展开" : "收起" }}</el-link
          >
        </div>
      </div>
      <div class="submit-content">
        <div class="bor"></div>
        <div class="btn">
          <el-button size="small" @click="dialogExamine = false"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="submitForm"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="bigImgList"
    />
  </div>
</template>

<script>
import { queryDeclare, specialBatchAudit, queryTrainingMessage } from "@/api/topicLecture";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { setItem } from "@/utils/storage.js";

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      detailForm: {},
      dialogImgVisible: false,
      isShowIcon: false,
      showViewer: false,
      dialogExamine: false,
      dialogImageUrl: "",
      rules: {
        name: [{ required: true, message: "请输入学员名字", trigger: "blur" }],
        examineResult: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
        sendObj: [
          { required: true, message: "请选择发送对象", trigger: "change" },
        ],
        notice: [
          { required: true, message: "请选择短信通知", trigger: "change" },
        ],
        auditContent: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
      examineForm: {
        auditSchedule: 2,
        noticeType: 0,
        auditContent: "",
        isNotice: true,
        uuids: "",
        msg: "",
      },
      sendObj: "",
      uuids: "",
      textOpenFlag: false,
      showBtnFlag: false,
      sitePhotoArr: null,
      attachmentName: null,
      attachmentUrl: null,
      isPreview: null,
      bigImgList: [],
      attachmentArr: [],
      sendMessageArr: [],
      sendMessageOrigin: "", // 短信模版-原始
      type: '审核详情'
    };
  },
  watch: {
    dialogExamine(val) {
      if (!val) {
        this.$refs.examineForm.resetFields();
      } else {
        this.$nextTick(() => {
          this.calculateText();
        });
      }
      this.examineForm.auditContent = "";
    },
  },
  created() {
    this.type = this.$route.query.type;
    this.getDetailData();
  },
  methods: {
    async getDetailData() {
      let { data, code } = await queryDeclare({ uuid: this.$route.query.uuid });
      if (code == 0) {
        this.detailForm = data;
      }
      if (this.detailForm.sitePhotos && this.detailForm.sitePhotos.length > 0) {
        this.sitePhotoArr = JSON.parse(this.detailForm.sitePhotos);
      }
      if (this.detailForm.attachment && this.detailForm.attachment.length > 0) {
        this.attachmentArr = JSON.parse(this.detailForm.attachment);
        this.attachmentName = this.attachmentArr[0].name;
        this.attachmentUrl = this.attachmentArr[0].url;
        let imgType = ["png", "jpg", "jpeg", "gif", "svg"];
        this.isPreview = imgType.includes(this.attachmentName.split(".")[1]);
      }
    },
    showImgPreview() {
      if (this.isPreview) {
        this.showViewer = true;
        this.bigImgList = [this.attachmentArr[0].url];
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    calculateText() {
      let twoHeight = 25 * 2; // 固定内容的高度
      this.textHeight = `${twoHeight}px`; // 获取内容元素的高度
      this.curHeight = this.$refs.desc.offsetHeight;
      if (this.curHeight > twoHeight) {
        this.textOpenFlag = true;
        this.showBtnFlag = true;
      } else {
        this.textOpenFlag = false;
        this.showBtnFlag = false;
      }
    },
    // 批量审核确认提交
    submitForm() {
      this.$refs.examineForm.validate(async (valid) => {
        if (valid) {
          let params = { ...this.examineForm };
          params.uuids = [];
          params.uuids.push(this.uuids);
          if (params.auditSchedule == 1) {
            params.auditContent = "";
          }
          let { msg, code } = await specialBatchAudit(params);
          if (code == 0) {
            this.$message.success(msg);
            this.dialogExamine = false;
            this.$Bus.$emit("topicLectureRefresh");
            this.$router.push({ path: "/topicLectureReview" });
            
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    imgIconEvent(url) {
      this.dialogImgVisible = true;
      this.dialogImageUrl = url;
    },
    // 获取短信模版
    getSmsTemplate() {
      let params = {
        uuid: this.detailForm.uuid
      };
      queryTrainingMessage(params).then((res) => {
        if (res.code !== 0) return;
        if (res.data.length > 1) {
          this.sendMessageArr = res.data; // 0:通过；1不通过
          this.handleMessage();
        }
      });
    },
    handleMessage() {
      // 1:同意、2不同意 默认-审核不通过
      if (this.examineForm.auditSchedule == 1) {
        this.examineForm.msg = this.sendMessageArr[0].message;
        let receiveUserList = this.sendMessageArr[0].receiveUserList.map(x => x.receiveUserName);
        this.sendObj = receiveUserList.join('、');
        this.examineForm.uuids = this.sendMessageArr[0].receiveUserList.map(x => x.receiveUserUUId);
      } else {
        this.examineForm.msg = this.sendMessageArr[1].message;
        this.sendMessageOrigin = this.sendMessageArr[1].message; // 审核不通过文案
        let receiveUserList = this.sendMessageArr[1].receiveUserList.map(x => x.receiveUserName);
        this.sendObj = receiveUserList.join('、');
        this.examineForm.uuids = this.sendMessageArr[1].receiveUserList.map(x => x.receiveUserUUId);
        this.generateSendMessage();
      }
    },
    // 短信通知按钮
    msgNoticeEvent(val) {
    },
    // 驳回原因输入框触发事件
    reasonInputEvent() {
      this.generateSendMessage();
    },
    // 审核结果按钮
    examineResultEvent(val) {
      // 1:同意、2不同意
      this.examineResultLable = val;
      if (val == 1) {
        this.examineForm.isNotice = false;
      } else {
        this.examineForm.isNotice = true;
      }
      this.handleMessage();
    },
    // 短信模版拼接
    generateSendMessage() {
      let flag =
        this.examineForm.auditContent &&
        this.examineForm.auditContent.length > 0;
      if (flag) {
        this.examineForm.msg = this.sendMessageOrigin.replace(
          "{驳回原因}",
          `${this.examineForm.auditContent}。`
        );
      } else
        this.examineForm.msg = this.sendMessageOrigin.replace("{驳回原因}", "");
    },
    // 审核
    submit(userName, uuid) {
      this.dialogExamine = true;
      this.studentArr = this.detailForm.userName;
      this.lectureName = this.detailForm.lectureName;
      this.uuids = uuid;
      this.getSmsTemplate();
    },

    //附件下载
    downloadFile() {
      if (this.attachmentUrl.length > 0) {
        fetch(this.attachmentUrl)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = this.attachmentName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
      } else {
        this.$message.warning("下载Url为空");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .img-dialog {
    /deep/.el-dialog__header {
      background: white !important;
    }
  }
  padding: 20px;
  .el-dialog {
    .el-form-item {
      margin-bottom: 15px !important;
    }
  }
  .submit-content {
    display: flex;
    flex-direction: column;
    margin: 65px 0 -15px 0;
    .btn {
      display: flex;
      justify-content: flex-end;
      margin: 17px 0 0;
    }
    .bor {
      border-top: 1px solid #ccc;
      margin: 0 -38px;
    }
  }
  .sendobj-content {
    display: flex;
    .lable {
      width: 78px;
      margin-left: 18px;
      position: relative;
      &::after {
        z-index: 3;
        content: "*";
        position: absolute;
        top: 1px;
        left: -10px;
        color: red;
      }
    }
  }
  .content {
    .submit-btn {
      display: flex;
      justify-content: center;
    }
    .timeline {
      margin-top: 40px;
      .timeline-box {
        margin-top: 32px;
        // padding: 35px 75px 0 75px;
      }
      .title {
        font-size: 14px;
        font-weight: bolder;
        background: #f2f3f4;
        padding: 15px 18px;
      }
    }
    padding: 20px 30px;
    .img-box {
      margin-top: 20px;
      .img-item {
        position: relative;
        display: inline-block;
        margin-right: 15px;
        &:hover {
          opacity: 0.65;
          i {
            display: block;
          }
        }
        i {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 100px;
          top: 45px;
          cursor: pointer;
          display: none;
        }
      }
      .img {
        width: 220px;
        height: 120px;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }

    .file_style {
      color: #3a85ff;
      cursor: pointer;
      margin-left: 16px;
    }
    .unClick_style {
      color: #96a1b2;
      cursor: not-allowed;
      margin-left: 16px;
    }
  }
  .header {
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
    font-size: 14px;
  }
  .margin-top-10 {
    margin-top: 10px;
  }
  .audit_item {
    margin-bottom: 10px;
    .status_style {
      color: #f97016;
      margin-left: 16px;
    }
  }
}
</style>
